import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarPermiso = async (permiso) => {
    try {
        if (permiso.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/permisos/${permiso.id}`,
                permiso,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/permisos`,
            permiso,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarPermiso = async (id_permiso) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/permisos/${id_permiso}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarPermiso = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/permisos/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const asignarPermiso = async (
    idPersona,
    crearPermisos,
    eliminarPermisos
) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/permisos/asignar/${idPersona}`,
            { crearPermisos, eliminarPermisos },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerPermisos = async (id_persona) => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/permisos/obtener/${id_persona}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
